import type { FaqItem } from "@/components/sections/products/shared/faq/types";
import { DOCS } from "@/lib/constants";

// German translation of MOBILE_PRODUCT_FAQS (same 11 questions, same hrefs).
// "Carrier" avoided throughout per content policy — translated as "mobile
// IP-Identität" / "echtes mobiles Netz".
export const MOBILE_PRODUCT_FAQS_DE: FaqItem[] = [
  {
    q: "Wie funktioniert die Abrechnung nach Per-GB?",
    a: "Sie zahlen nur für das genutzte Datenvolumen, zu einem festen Satz von $2/GB über alle Plan-Stufen, mit Zugriff auf einen großen Proxy-Pool und ohne Begrenzung der Anzahl an Access Points. Jederzeit skalierbar, ohne feste Proxy-Anzahl verwalten zu müssen.",
    link: { label: "Per-GB-Dokumentation lesen", href: DOCS.mobilePerGbPlan },
  },
  {
    q: "Kann ich gezielt bestimmte Städte ansteuern?",
    a: "Ja. Proxidize Mobile Proxies unterstützen Städte-Targeting und ASN/ISP-Targeting. Die Stadt wird im Dashboard bei der Proxy-Konfiguration ausgewählt.",
  },
  {
    q: "Ist eine KYC-Verifizierung erforderlich?",
    a: "Ja. Wir verlangen von allen Kunden eine KYC-Verifizierung (Know Your Customer), um Compliance sicherzustellen und Missbrauch unseres Netzwerks zu verhindern.",
  },
  {
    q: "Wie schnell sind Proxidize Mobile Proxies?",
    a: "Die Geschwindigkeit liegt durchschnittlich bei 10–50 Mbps an allen Standorten, mit Spitzenwerten bis zu 100 Mbps.",
  },
  {
    q: "Wie funktioniert die IP-Rotation?",
    a: "IPs lassen sich bei jeder Anfrage sofort rotieren oder für bis zu 3 Tage in einer sticky Session halten, je nach Workflow. Die Rotation lässt sich pro Access Point direkt im Dashboard oder über die API einstellen.",
    link: { label: "Rotations-Endpunkte in der API-Referenz", href: DOCS.apiPerGbMobile },
  },
  {
    q: "Was passiert, wenn mein Proxy-Endpunkt ausfällt?",
    a: "Unser automatisiertes Failover-System überwacht alle mobilen Endpunkte fortlaufend. Bei einem Ausfall wird innerhalb von Millisekunden auf den nächsten verfügbaren Endpunkt gewechselt, ohne dass sich Ihre Proxy-Zugangsdaten ändern.",
    link: { label: "Anleitung zur Fehlerbehebung", href: DOCS.troubleshooting },
  },
  {
    q: "Welche Protokolle werden unterstützt?",
    a: "HTTP, HTTPS und SOCKS5 in allen Plänen.",
  },
  {
    q: "Kann ich Mobile Proxies mit KI-Agenten nutzen?",
    a: "Ja. Der tatsächliche Datenverkehr des Agenten läuft über HTTP, HTTPS oder SOCKS5 — ein Playwright-Beispiel mit generierten mobilen Zugangsdaten findet sich im Entwickler-Bereich. Die REST-API und der Open-Source-Proxidize-MCP-Server sind separate Schnittstellen zur Verwaltung der Access Points (Städte-Rotation, Zugangsdaten erzeugen), nicht zum Routing des Datenverkehrs selbst. Mobile IPs eignen sich, wenn eine Aufgabe gezielt eine echte mobile IP-Identität benötigt, etwa um zu prüfen, wie eine lokalisierte Landingpage oder eine mobile Anzeige in einem echten mobilen Netz dargestellt wird.",
    link: {
      label: "Mobile Proxies für Entwickler",
      href: "/proxy-server/mobile-proxies#mobile-for-developers-heading",
    },
  },
  {
    q: "Sollte mein Agent Residential oder Mobile Proxies nutzen?",
    a: "Residential ist in der Regel der Einstieg für umfangreiche Datenerfassung — geringere Kosten pro GB, Abdeckung in 195+ Ländern und IPs, die sich in den alltäglichen Datenverkehr einfügen. Mobile Proxies eignen sich, wenn der Workflow gezielt eine mobile IP-Identität benötigt, etwa um zu prüfen, wie Inhalte, Preise oder Anzeigen für echte Nutzer eines mobilen Netzes in einer bestimmten Stadt erscheinen.",
    link: {
      label: "Mobile vs. Residential vergleichen",
      href: "/proxy-server/mobile-proxies#compare-proxies",
    },
  },
  {
    q: "Wie wähle ich einen Anbieter für rotierende Mobile Proxies aus?",
    a: "Netzabdeckung, Rotationskontrolle, Städte-Targeting, Erfolgsquote und Preismodell zwischen Anbietern vergleichen, bevor eine Entscheidung getroffen wird.",
    link: {
      label: "Beste Anbieter für rotierende Mobile Proxies",
      href: "/blog/best-rotating-mobile-proxy-providers/",
    },
  },
  {
    q: "Gibt es eine Geld-zurück-Garantie?",
    a: "Ja. Alle Pläne haben eine 30-tägige Geld-zurück-Garantie, sofern weniger als 10 GB Datenvolumen im jeweiligen Plan verbraucht wurden.",
  },
];
